export const YES_NO_KEYS = {
  YES: 'YES',
  NO: 'NO',
};

export const YES_NO_LABELS = {
  [YES_NO_KEYS.YES]: 'Si',
  [YES_NO_KEYS.NO]: 'No',
};

export const YES_NO_OPTIONS = [
  {
    id: 1,
    label: YES_NO_LABELS.YES,
    key: YES_NO_KEYS.YES,
    boolean: true,
  },
  {
    id: -1,
    label: YES_NO_LABELS.NO,
    key: YES_NO_KEYS.NO,
    boolean: false,
  },
];
